import { useEffect } from 'react';

export const smoothScroll = (elementId: string) => {
  const element = document.getElementById(elementId);
  if (element) {
    const yOffset = -64; // Account for fixed header height
    const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }
};

export const usePreventScrollFreeze = () => {
  useEffect(() => {
    const preventDefault = (e: TouchEvent) => {
      e.preventDefault();
    };

    // Only prevent default on modal elements
    const modalElements = document.querySelectorAll('.modal');
    modalElements.forEach(element => {
      element.addEventListener('touchmove', preventDefault, { passive: false });
    });
    
    return () => {
      modalElements.forEach(element => {
        element.removeEventListener('touchmove', preventDefault);
      });
    };
  }, []);
};